
export const creator = {
  hero: {
    title: "Build Your Digital Presence",
    subtitle: "Simple Platform for Content Creators",
    description: "Create a personal page, sell digital products, and build community."
  },
  benefits: {
    title: "Why Choose Us?",
    subtitle: "Everything a Content Creator Needs",
    items: [
      {
        title: "Easy Setup",
        description: "Set up your own page in minutes, no technical knowledge required."
      },
      {
        title: "Customizable Appearance",
        description: "Customize every detail to match your own taste."
      },
      {
        title: "Multiple Revenue Streams",
        description: "Digital products, personalized videos, consultations, and more options."
      },
      {
        title: "Analytics and Statistics",
        description: "Track performance of your content and increase your revenue."
      }
    ],
    freedom: {
      title: "Creative Freedom",
      description: "Express yourself without restrictions or platform limitations."
    },
    revenue: {
      title: "Multiple Revenue Streams",
      description: "Earn from content sales, consultations, and personalized services."
    },
    immediate: {
      title: "Immediate Results",
      description: "Start earning as soon as your profile is set up and approved."
    },
    secure: {
      title: "Secure Payments",
      description: "All transactions are processed securely with industry-standard protection."
    },
    cta: "Get Started Today"
  },
  newsletter: {
    title: "Subscribe to Our Newsletter",
    subtitle: "Be the first to know about the latest features",
    placeholder: "Enter your email",
    button: "Subscribe",
    successMessage: "Successfully subscribed!"
  }
};
